import { useCallback } from 'react';
import { useRecoilValue } from 'recoil';
import {
    environmentState,
    secondaryEnvironmentState,
    viewManagerState,
} from '~/state/atoms/engineAtoms';

export default function useViewManagerEvents() {
    const environment = useRecoilValue(environmentState);
    const secondaryEnvironment = useRecoilValue(secondaryEnvironmentState);
    const viewManager = useRecoilValue(viewManagerState);

    const handleZoomScaleSync = useCallback(() => {
        if (!environment || !secondaryEnvironment || !viewManager) {
            return;
        }
        viewManager.syncPanZoomToSecondary(environment, secondaryEnvironment);
    }, [environment, secondaryEnvironment, viewManager]);

    const handleIntersectionPointSync = useCallback(() => {
        if (!environment || !secondaryEnvironment || !viewManager) {
            return;
        }

        const { registration } = secondaryEnvironment;
        if (!registration) {
            return;
        }

        const mapped = viewManager.mapPrimaryToSecondaryPatient(
            environment,
            secondaryEnvironment,
            registration
        );

        if (mapped) {
            secondaryEnvironment.planeIntersectionPoint.coordinates = mapped;
        }
    }, [environment, secondaryEnvironment, viewManager]);

    return {
        handleIntersectionPointSync,
        handleZoomScaleSync,
    };
}
